module.exports = __webpack_public_path__ + "img/bgDescribe1.b2ae6d4d.png";